import { createEpic } from "../helpers";

import {
	getLinksListAsyncAction,
	postLinksManyAsyncAction,
	truncateLinksAsyncAction,
} from "./youtubeActions";

export const getYoutubeLinksListEpic = createEpic(
	getLinksListAsyncAction,
	"youtube",
	"getLinksList",
	true
);

export const postYoutubeLinksManyEpic = createEpic(
	postLinksManyAsyncAction,
	"youtube",
	"postLinksMany",
	true
);

export const truncateYoutubeLinksEpic = createEpic(
	truncateLinksAsyncAction,
	"youtube",
	"truncateLinks",
	true
);
